import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "userinforegistration" }
const _hoisted_2 = { class: "mt-20 flex h-screen flex-col items-center bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-lg font-medium" }, "お名前（本名）を入力してください", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "my-6" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "my-11 w-9/12" }, " 入力したお名前は他人に知られることはありません。管理に使用します。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.realName) = $event)),
          type: "text",
          maxlength: "30",
          class: "h-12 w-full rounded border border-gray-800 pl-5 text-lg"
        }, null, 512), [
          [_vModelText, _ctx.realName]
        ]),
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
          class: "w-full rounded-md bg-sky-400 py-3 text-center text-2xl font-semibold text-black hover:bg-sky-500 hover:text-white"
        }, " 登録 ")
      ], 32),
      _hoisted_5
    ])
  ]))
}